var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgFlagFr(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#002654",
    d: "M0 0h213.3v480H0z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#ce1126",
    d: "M426.7 0H640v480H426.7z"
  })));
}
export default SvgFlagFr;